// extracted by mini-css-extract-plugin
module.exports = {"image":"about-module--image--1GeET","container":"about-module--container--2LqW7","content":"about-module--content--IaIHo","actions":"about-module--actions--6B1_m"};